import { useEffect } from "react";

export function useScrollLock(isLocked, lockClass, capturedScrollPosition) {
  useEffect(() => {
    if (!isLocked) return undefined;
    const scrollPosition = Number.isFinite(capturedScrollPosition) ? capturedScrollPosition : window.scrollY;
    const originalScrollBehavior = document.documentElement.style.scrollBehavior;
    const restoreScrollPosition = () => {
      if (window.scrollY !== scrollPosition) {
        window.scrollTo({ top: scrollPosition, behavior: "auto" });
      }
    };
    document.documentElement.style.scrollBehavior = "auto";
    restoreScrollPosition();
    document.documentElement.classList.add(lockClass);
    document.body.classList.add(lockClass);
    window.addEventListener("scroll", restoreScrollPosition, { passive: true });
    return () => {
      window.removeEventListener("scroll", restoreScrollPosition);
      document.documentElement.classList.remove(lockClass);
      document.body.classList.remove(lockClass);
      restoreScrollPosition();
      document.documentElement.style.scrollBehavior = originalScrollBehavior;
    };
  }, [capturedScrollPosition, isLocked, lockClass]);
}